import { EnvironmentProviders } from "@angular/core";
import { provideQuillConfig } from "ngx-quill";


export const QuillProvider: EnvironmentProviders = provideQuillConfig({
    modules: {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike', { 'list': 'ordered'}, { 'list': 'bullet' }, 'link'],
        ]
    }
})